import { Text } from 'basic-ui-lib/components/Text';
import { Colors } from 'basic-ui-lib/constants';
import styled from 'styled-components';

export interface ItemMenuProps {
  key?: string;
  icon?: React.ReactNode;
  title?: string;
  onClick?: () => void;
}

const ItemMenu = ({ icon, title, onClick }: ItemMenuProps) => {
  return (
    <Container onClick={onClick}>
      {icon && <>{icon}</>}
      <Text body_1 medium>
        {title}
      </Text>
    </Container>
  );
};

export default ItemMenu;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
  background-color: ${Colors.neutral.bg[1]};
  border-bottom: 1px solid ${Colors.neutral.border[1]};
  height: 48px;
`;
